{
  "guidance": {
    "help": {
      "entry": "Help & tours",
      "panelTitle": "Help & tours",
      "intro": "Short guides to what you can do here. A guide only points and explains; it never changes anything.",
      "thisPage": "Guide me on this page",
      "thisPageHint": "Explains this page without leaving it.",
      "guideWith": "Guide me: {{title}}",
      "toursHeading": "Guides",
      "none": "No guide is available for your access yet.",
      "steps": "Steps in this guide ({{count}})",
      "status": {
        "notStarted": "Not started",
        "inProgress": "In progress",
        "completed": "Completed",
        "running": "Running now"
      },
      "start": "Start",
      "continue": "Continue",
      "restart": "Restart",
      "startNamed": "Start: {{title}}",
      "continueNamed": "Continue: {{title}}",
      "restartNamed": "Restart: {{title}}",
      "browserOnly": "Progress is saved in this browser only.",
      "groups": {
        "workflows": "Guided workflows",
        "workflowsHint": "Step by step through a real task. You do every step yourself; the coach never presses anything for you.",
        "oriented": "Get oriented",
        "explain": "Screen guides",
        "explainHint": "Short guides that explain a screen. They only point; they never change anything."
      },
      "show": "Show coach",
      "showNamed": "Show coach: {{title}}",
      "restartNote": "Restart begins again at the first step. It undoes nothing you did."
    },
    "card": {
      "progress": "Step {{current}} of {{total}}",
      "back": "Back",
      "next": "Next",
      "finish": "Finish",
      "close": "Close guide",
      "retry": "Try again",
      "commitNote": "The guide will not do this for you. Finish the guide, then act when you are ready."
    },
    "pause": {
      "title": "Guide paused",
      "missing": "This part of the page is not showing right now. It may need data or access that is not available here.",
      "dirty": "This page has unsaved changes, so the guide will not leave it. Save or discard them, then choose Continue in Help & tours.",
      "permission": "This guide is no longer available for your access.",
      "record": "Open the record you want to work on first, then choose Continue in Help & tours.",
      "error": "Something went wrong showing this step. Nothing on the page was changed. Try again, or close the guide.",
      "leftPage": "The page changed, so the guide paused here. Choose Continue in Help & tours when you are ready."
    },
    "invitation": {
      "title": "New here?",
      "body": "A one-minute guide shows where things are. It changes nothing.",
      "start": "Show me around",
      "dismiss": "Not now"
    },
    "tours": {
      "T01": {
        "title": "Find your way around",
        "summary": "Where your menu, your work, the language switch and Help are.",
        "welcome": {
          "title": "Your workspace",
          "body": "This short guide shows where things are. It only points; it never opens, saves or sends anything for you."
        },
        "navigation": {
          "title": "Your menu",
          "body": "Everything your role lets you use is here. Areas you cannot use are not shown at all."
        },
        "bottomNavigation": {
          "title": "Quick navigation",
          "body": "On a phone or tablet, your most-used places sit at the bottom. More opens the full menu."
        },
        "yourWork": {
          "title": "Your work",
          "body": "The dashboard starts with what needs you: your requests, decisions or deliveries waiting for you, or your organisation's figures, depending on your role."
        },
        "language": {
          "title": "Arabic or English",
          "body": "Switch the language at any time. Your work stays exactly as it is."
        },
        "help": {
          "title": "Help & tours",
          "body": "Open this whenever you need a guide. Progress is saved in this browser only."
        }
      },
      "T10": {
        "title": "Your supplier portal",
        "summary": "Whom you are supplying, what needs you, and how to answer, dispatch and invoice an order.",
        "context": {
          "title": "Whom you are supplying",
          "body": "The header names your company and the buyer you are working with. Everything here belongs to that buyer only."
        },
        "home": {
          "title": "What needs you",
          "body": "Home lists what is waiting on you: orders to confirm, dispatch or invoice, and enquiries to price. When nothing is waiting, it says so."
        },
        "orders": {
          "title": "Your orders",
          "body": "Every order this buyer has sent you, with its current version and what it needs next. Open an order to answer it."
        },
        "openOrder": "Open an order from your orders, then choose Continue in Help & tours.",
        "orderStatus": {
          "title": "This order",
          "body": "The version you are answering, and where the order, your answer and delivery stand, each shown apart. Invoicing is not shown here."
        },
        "orderAnswer": {
          "title": "Your answer",
          "body": "Confirm this version, give a delivery date, report a shortfall line by line, ask a question, or decline with a reason. This guide sends nothing."
        },
        "orderDispatch": {
          "title": "Record a dispatch",
          "body": "Tell the buyer a consignment has left, with its delivery note reference. You can record more than one, and the order need not be confirmed first."
        },
        "orderInvoice": {
          "title": "Your invoices for this order",
          "body": "Send the invoice you issued, as a PDF. It is kept as evidence against the order version; it is not a payment request."
        }
      },
      "T12": {
        "title": "Platform operations",
        "summary": "Navigation and figures, the organisations, and an organisation's first administrator and sections.",
        "navigation": {
          "title": "Navigation",
          "body": "Overview and organisations, and your sign-in security once two-step sign-in is set up."
        },
        "metrics": {
          "title": "Platform figures",
          "body": "Counts across all organisations, read-only. Nothing here reaches into a customer's procurement."
        },
        "definitions": {
          "title": "What the figures mean",
          "body": "How each figure is counted, so that everyone reads it the same way."
        },
        "organisations": {
          "title": "Organisations",
          "body": "Every customer organisation with its status. Search by name or narrow by status; the filters stay in the address. Open one to see its administrator, capacity and setup."
        },
        "openOrganisation": "Open an organisation from the list, then choose Continue in Help & tours.",
        "create": {
          "title": "Create an organisation",
          "body": "Opens the form that creates an organisation and invites its first administrator. The invitation link is never shown to you. This guide creates nothing."
        },
        "administrator": {
          "title": "First administrator",
          "body": "Whether the first administrator has activated the account, and when the invitation expires. Resend invitation, where your role allows it, sends a new link and stops the old one; this guide does not press it."
        },
        "sections": {
          "title": "The organisation's sections",
          "body": "Subscription and capacity: the plan, the pilot and purchasing-unit capacity. Setup: the setup steps done so far. History, if your role may see it: commercial events. Billing, discounts and plan changes are not operated here."
        }
      }
    },
    "coaches": {
      "actions": {
        "ready": "I'm ready",
        "pause": "Pause",
        "close": "Close coach",
        "skip": "Skip explanation",
        "return": "Return",
        "returnTo": "Return to {{page}}"
      },
      "handoff": {
        "title": "You will now perform the real action",
        "note": "The coach will not press it for you. It moves on only when the page confirms what happened."
      },
      "dock": {
        "waiting": "Waiting for you. The coach does nothing on its own.",
        "pending": "The page is sending what you did. Wait for its answer.",
        "confirming": "Waiting for the page to show the result.",
        "failed": "That did not go through. The page says why. The coach changed nothing.",
        "away": "You left this step. Return to {{page}} to continue.",
        "awayNoReturn": "You left this step. Go back to {{page}} to continue; the coach waits.",
        "awayUnnamed": "You left this step. Go back to continue; the coach waits.",
        "field": "Finish the field you are in. The coach continues when you leave it.",
        "minimise": "Minimise the coach",
        "show": "Show coach: {{context}}"
      },
      "pause": {
        "title": "Coach paused",
        "missing": "This part of the page is not showing right now. It may need data or access that is not available here. Nothing was changed.",
        "permission": "This coach is no longer available for your access.",
        "error": "Something went wrong showing this step. Nothing on the page was changed. Try again, or pause the coach."
      },
      "resume": {
        "title": "Continue “{{title}}”?",
        "body": "You were at step {{current}} of {{total}}. The coach checks what the page shows now and assumes nothing.",
        "later": "Not now"
      },
      "pages": {
        "tenant": {
          "catalogue": "the catalogue",
          "catalogue-item": "the item",
          "cart": "your cart",
          "request": "your request",
          "approvals": "your approvals",
          "approval": "the assigned request",
          "receiving": "the receiving queue",
          "receive": "the receipt form"
        },
        "vendor": {
          "orders": "your orders",
          "order": "the order",
          "rfqs": "your enquiries",
          "rfq": "the enquiry"
        },
        "platform": {
          "organisations": "the organisations",
          "organisation-new": "the creation form"
        }
      },
      "C01": {
        "title": "Create your first request",
        "summary": "From the catalogue to a submitted request, step by step. You do each step; the coach shows the way.",
        "welcome": {
          "title": "Create your first request",
          "body": "This coach walks with you from the catalogue to a submitted request. You choose, add, review and submit yourself, with the page's own buttons. The coach only shows the way: it never presses anything and never changes your data."
        },
        "search": {
          "title": "Find an approved item",
          "body": "Search by an item's name or code, or narrow the list. An item you can order shows its agreed price; an item you cannot order says why."
        },
        "openItem": {
          "title": "Open an item",
          "body": "Choose the name of an item you can order to see its terms."
        },
        "terms": {
          "title": "The agreed price and terms",
          "body": "The price, the supplier, the tax and the minimum order come from the approved agreement for your purchasing unit. You cannot change them here."
        },
        "quantity": {
          "title": "Choose the quantity",
          "body": "Enter how many you need, in the ordering unit shown. It starts at the smallest quantity the agreement allows."
        },
        "add": {
          "title": "Add the item to your cart",
          "body": "Choose Add to cart, beside the quantity.",
          "consequence": "This puts the item in your cart. Nothing is sent for approval yet, and no budget is reserved.",
          "waiting": "Choose Add to cart when you are ready. The coach waits for the page to confirm it.",
          "disabled": "Add to cart is not available right now. Enter a quantity first."
        },
        "openCart": {
          "title": "Open your cart",
          "body": "The page confirmed the item is in your cart. Choose Open cart in the confirmation, or Cart in the menu."
        },
        "lines": {
          "title": "Your cart",
          "body": "Each line with its agreed price and quantity. You can change a quantity or remove a line; a change saves when you leave the field."
        },
        "details": {
          "title": "When and why",
          "body": "Give the date you need it by and a business reason. Approvers read them when they decide."
        },
        "budget": {
          "title": "Budget",
          "body": "What this request would use from your budget, as the server calculates it. Nothing is reserved until you submit.",
          "absent": "No budget figure shows for this cart. Where a budget applies, the page shows here what the request would use from it."
        },
        "review": {
          "title": "Review & submit",
          "body": "Choose Review & submit. The page checks your cart again; this changes nothing."
        },
        "controls": {
          "title": "Buying controls",
          "body": "What the server checked again: any exception to the rules, and anything that stops this request from being submitted."
        },
        "route": {
          "title": "Expected approval route",
          "body": "Who must approve this request under your organisation's rules, as the server expects it now."
        },
        "submit": {
          "title": "Submit your request",
          "body": "Choose Submit request, at the end of the review.",
          "waiting": "Choose Submit request when you are ready. The coach waits for the page to confirm it.",
          "disabled": "Submit request is not available: the buying controls on this page say why. Change your cart, then review it again."
        },
        "status": {
          "title": "Where your request stands",
          "body": "This is the status the server recorded for your request. It changes as the request moves on."
        },
        "nextAction": {
          "title": "What happens next",
          "body": "What happens next, and who has your request now."
        },
        "approvers": {
          "title": "Approvers",
          "body": "Each approval level, who holds it, and where your request is.",
          "absent": "No approval level is listed for this request. Its status says what happened to it."
        },
        "finish": {
          "title": "That is the whole journey",
          "body": "You raised a request from the catalogue and followed it to its own page. Find it again under My Requests."
        }
      },
      "C02": {
        "title": "Review a request",
        "summary": "Review an assigned request, decide through the normal controls, and read the recorded outcome.",
        "welcome": {
          "title": "Review your assigned work",
          "body": "Choose a request you are authorised to decide. The coach chooses no request and makes no decision."
        },
        "open": {
          "title": "Open a request",
          "body": "Open one assigned request. Delegated work names the person whose authority you use. If the inbox is empty, pause and return later."
        },
        "lines": {
          "title": "Read the requested items",
          "body": "Check the requester, quantities, prices and supporting details before deciding."
        },
        "budget": {
          "title": "Check the budget",
          "body": "Read the budget position and exceptions shown by the server. A warning is not permission to bypass policy."
        },
        "policy": {
          "title": "Read why this needs you",
          "body": "Review policy exceptions, overdue work and the current approval holder. Approve, partially approve, return and reject have different effects."
        },
        "decide-handoff": {
          "title": "Make your decision",
          "body": "You will now perform the real action. Choose the appropriate decision and complete its confirmation with any required reason. The server records your decision.",
          "consequence": "You will now perform the real action. Choose the appropriate decision and complete its confirmation with any required reason. The server records your decision."
        },
        "decide": {
          "title": "Waiting for your decision",
          "body": "Use the page's decision controls. A refused decision keeps this step; correct the issue shown by the page."
        },
        "result": {
          "title": "Read the recorded result",
          "body": "The result names the decision and the request's current state. Open the request to inspect its timeline if needed; approval does not issue an order."
        },
        "finish": {
          "title": "Review complete",
          "body": "You reviewed the server's recorded result. Finish closes only the coach."
        }
      },
      "C05": {
        "title": "Record a delivery",
        "summary": "Check remaining quantities, record what arrived, and inspect the receipt history.",
        "welcome": {
          "title": "Choose a delivery",
          "body": "Choose an order from your receiving queue. You record physical evidence; this does not make a payment or update an inventory ledger."
        },
        "open": {
          "title": "Open the delivery",
          "body": "Open the order you are receiving. An empty queue means nothing is available within your access."
        },
        "facts": {
          "title": "Check the delivery facts",
          "body": "Match the supplier, order version and dispatch information to the delivery you have."
        },
        "lines": {
          "title": "Enter what arrived",
          "body": "Compare ordered, received and remaining quantities. Enter delivered and accepted quantities for a partial delivery; explain any short, damaged or incorrect items."
        },
        "details": {
          "title": "Add delivery evidence",
          "body": "Add the delivery note reference and notes where available. Everything arrived correctly is appropriate only when every remaining item did arrive correctly."
        },
        "record-handoff": {
          "title": "Record the actual delivery",
          "body": "You will now perform the real action. Press the normal receipt button after checking your entries. This records receipt evidence and changes received and remaining quantities.",
          "consequence": "You will now perform the real action. Press the normal receipt button after checking your entries. This records receipt evidence and changes received and remaining quantities."
        },
        "record": {
          "title": "Waiting for the receipt",
          "body": "Use the page's receipt button. Validation or a server refusal stays on this step until corrected."
        },
        "history": {
          "title": "Inspect the receipt history",
          "body": "Check the new receipt and any exceptions. A short delivery remains outstanding until an authorised buyer records a separate close-short decision."
        },
        "finish": {
          "title": "Receipt checked",
          "body": "The receipt confirmation and history are the evidence. Finish closes only the coach."
        }
      },
      "C07": {
        "title": "Reply to an RFQ",
        "summary": "Read the buyer's need, enter your offer, and submit it yourself.",
        "welcome": {
          "title": "Choose an enquiry",
          "body": "Choose an open enquiry for this buyer. The coach never selects a buyer, supplier, price or response for you."
        },
        "open": {
          "title": "Open an invitation",
          "body": "Open an enquiry you are invited to answer. Check that its response deadline has not passed."
        },
        "requirement": {
          "title": "Read the requirement",
          "body": "Check the quantities, units, deadline and buyer's terms. Your quote is evidence for the buyer's decision, not an order."
        },
        "offer": {
          "title": "Enter the offer",
          "body": "Enter your prices and tax, validity, minimum order quantity, lead time and availability. Use your actual proposed terms."
        },
        "documents": {
          "title": "Supporting documents",
          "body": "If you choose to upload a document, the page performs a real upload. Check attachments and the current offer before sending."
        },
        "send-handoff": {
          "title": "Send your quote",
          "body": "You will now perform the real action. Press the page's send button. The buyer will receive this quote or revision; the coach submits nothing.",
          "consequence": "You will now perform the real action. Press the page's send button. The buyer will receive this quote or revision; the coach submits nothing."
        },
        "send": {
          "title": "Waiting for your quote",
          "body": "Correct any validation or deadline refusal on the page. The coach continues only after submission succeeds and the invitation state updates."
        },
        "result": {
          "title": "Check the recorded offer",
          "body": "Read the recorded offer and status. Submitting a quote is not an award; the buyer decides separately."
        },
        "finish": {
          "title": "Quote checked",
          "body": "Your own action submitted the quote. Finish closes only the coach."
        }
      },
      "C06": {
        "title": "Respond to an order",
        "summary": "Confirm a current order version, record a dispatch, and inspect the result.",
        "welcome": {
          "title": "Choose an order awaiting confirmation",
          "body": "Choose a current order you can confirm and dispatch. For a query, partial availability or decline, use the page's answer form and pause this confirmation walkthrough."
        },
        "open": {
          "title": "Open the current version",
          "body": "Open the order and check that it needs your confirmation. The coach never opens a document link, which may record an audit event."
        },
        "version": {
          "title": "Read the separate states",
          "body": "The order lifecycle, your response and fulfilment are separate. Check the version and any re-confirmation notice before answering."
        },
        "lines": {
          "title": "Check your commitment",
          "body": "Review quantities and prices. Use the answer panel if you need a delivery date, a query, partial availability or a decline with reason."
        },
        "confirm-handoff": {
          "title": "Confirm this version",
          "body": "You will now perform the real action. Press Confirm this version only if you can fulfil it. This records your acknowledgement of this order version.",
          "consequence": "You will now perform the real action. Press Confirm this version only if you can fulfil it. This records your acknowledgement of this order version."
        },
        "confirm": {
          "title": "Waiting for confirmation",
          "body": "The page confirms the server's acknowledgement. If confirmation is unavailable, pause and use the appropriate answer on the page."
        },
        "dispatch-handoff": {
          "title": "Record a real dispatch",
          "body": "You will now perform the real action. Enter the delivery note reference and dispatch date, then use the page's dispatch button only after the consignment has left. This records dispatch evidence.",
          "consequence": "You will now perform the real action. Enter the delivery note reference and dispatch date, then use the page's dispatch button only after the consignment has left. This records dispatch evidence."
        },
        "dispatch": {
          "title": "Waiting for dispatch evidence",
          "body": "Use the dispatch form yourself. The coach waits for its recorded confirmation, not a predicted delivery state."
        },
        "result": {
          "title": "Read the dispatch result",
          "body": "A dispatch is not a receipt or invoice. The buyer records what arrived, and invoices are submitted separately where permitted."
        },
        "finish": {
          "title": "Order response checked",
          "body": "Check the updated order states. Finish closes only the coach."
        }
      },
      "C08": {
        "title": "Provision an organisation",
        "summary": "Create an organisation through the permitted form and check its administrator invitation state.",
        "welcome": {
          "title": "Provision with care",
          "body": "This workflow creates a real organisation and administrator invitation. Use synthetic data only for a demo. The coach never bypasses your permissions or MFA."
        },
        "open": {
          "title": "Open the creation form",
          "body": "Use Create organisation yourself. The coach never opens an entry form automatically."
        },
        "details": {
          "title": "Check organisation and administrator",
          "body": "Review the organisation names, unique slug, commercial context supported by the form, and the first administrator's name and email."
        },
        "create-handoff": {
          "title": "Create and invite",
          "body": "You will now perform the real action. Use the normal creation button after checking the details. This creates an organisation and attempts to deliver its administrator invitation.",
          "consequence": "You will now perform the real action. Use the normal creation button after checking the details. This creates an organisation and attempts to deliver its administrator invitation."
        },
        "create": {
          "title": "Waiting for the recorded result",
          "body": "A refusal keeps this step and your form values. The coach continues only when the server returns the provisioning result."
        },
        "result": {
          "title": "Check delivery and readiness",
          "body": "Read the invitation delivery state. Handed to mail transport does not mean activated or received. Open the organisation detail to check readiness and the administrator's activation."
        },
        "finish": {
          "title": "Provisioning result checked",
          "body": "The server's result is the evidence. Finish closes only the coach; it does not activate the administrator."
        }
      }
    }
  }
}
